// Sentry initialization for the React frontend.
// Safe no-op when REACT_APP_SENTRY_DSN is unset (e.g. local dev without DSN).
import * as Sentry from "@sentry/react";

const DSN = process.env.REACT_APP_SENTRY_DSN;

export function initSentry() {
  if (!DSN) {
    console.info("[sentry] DSN not set, skipping init");
    return;
  }

  Sentry.init({
    dsn: DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: parseFloat(
      process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"
    ),
    replaysSessionSampleRate: parseFloat(
      process.env.REACT_APP_SENTRY_REPLAYS_SESSION_RATE || "0.0"
    ),
    replaysOnErrorSampleRate: parseFloat(
      process.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_RATE || "1.0"
    ),
  });
}

export { Sentry };
